export const fetchSeasonStats = async (teamId = 111) => {
  const year = new Date().getFullYear();
  const [teamStatsRes, leadersBattingRes, leadersPitchingRes] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/teams/${teamId}/stats?stats=season&group=hitting,pitching&season=${year}`),
    fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=homeRuns,battingAverage,runsBattedIn,stolenBases&teamId=${teamId}&season=${year}&limit=5&statGroup=hitting`),
    fetch(`https://statsapi.mlb.com/api/v1/stats/leaders?leaderCategories=era,strikeouts,wins&teamId=${teamId}&season=${year}&limit=5&statGroup=pitching`),
  ]);

  const teamStats = teamStatsRes.ok ? await teamStatsRes.json() : null;
  const leadersBatting = leadersBattingRes.ok ? await leadersBattingRes.json() : null;
  const leadersPitching = leadersPitchingRes.ok ? await leadersPitchingRes.json() : null;

  return { teamStats, leadersBatting, leadersPitching };
};